import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase/firebase'
import { doc, getDoc, collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

// Auth Views
import LoginView from '@/views/auth/LoginView.vue'

// Main (Public) Views
import HomeView from '@/views/main/HomeView.vue'
import PropertyListView from '@/views/main/property/PropertyListView.vue'
import PropertyDetailView from '@/views/main/property/PropertyDetailView.vue'
import ChatView from '@/views/main/ChatView.vue'

// Main Community Views
import CommunityListView from '@/views/main/community/CommunityListView.vue'
import CommunityDetailView from '@/views/main/community/CommunityDetailView.vue'
import CommunityWriteView from '@/views/main/community/CommunityWriteView.vue'

// Admin Views
import AdminHomeView from '@/views/admin/AdminHomeView.vue'
import AdminPropertyListView from '@/views/admin/PropertyListView.vue'
import PropertyCreateView from '@/views/admin/PropertyCreateView.vue'
import UserListView from '@/views/admin/UserListView.vue'
import PartnerApplicationsView from '@/views/admin/PartnerApplicationsView.vue'
import MainBannerManageView from '@/views/admin/MainBannerManageView.vue'
import HotAdManageView from '@/views/admin/HotAdManageView.vue'
import AdBannerApplicationsView from '@/views/admin/AdBannerApplicationsView.vue'
import PopupAdApplicationsView from '@/views/admin/PopupAdApplicationsView.vue'
import SplashAdApplicationsView from '@/views/admin/SplashAdApplicationsView.vue'
import MagazineManageView from '@/views/admin/MagazineManageView.vue'
import NoticeManageView from '@/views/admin/NoticeManageView.vue'
import PartnerNoticeManageView from '@/views/admin/PartnerNoticeManageView.vue'
import EventManageView from '@/views/admin/EventManageView.vue'
import FaqManageView from '@/views/admin/FaqManageView.vue'
import InquiryManageView from '@/views/admin/InquiryManageView.vue'
// Admin Points Views
import PointSettingsView from '@/views/admin/points/PointSettingsView.vue'
import ProductManageView from '@/views/admin/points/ProductManageView.vue'
import OrderManageView from '@/views/admin/points/OrderManageView.vue'
// Admin Partners Point Charge
import PointChargeManageView from '@/views/admin/PointChargeManageView.vue'
import PointGiveView from '@/views/admin/PointGiveView.vue'
// Admin Recommend Ad
import RecommendAdApplicationsView from '@/views/admin/RecommendAdApplicationsView.vue'
// Admin List Ad
import ListAdApplicationsView from '@/views/admin/ListAdApplicationsView.vue'
// Admin Community Report
import CommunityReportManageView from '@/views/admin/CommunityReportManageView.vue'
// Admin Community Ad
import CommunityAdApplicationsView from '@/views/admin/CommunityAdApplicationsView.vue'
// Admin Chat Ad
import ChatAdApplicationsView from '@/views/admin/ChatAdApplicationsView.vue'
// Admin Partners Dashboard
import PartnerDashboardBannerManageView from '@/views/admin/PartnerDashboardBannerManageView.vue'
import PartnerUpdateManageView from '@/views/admin/PartnerUpdateManageView.vue'
import PartnerSquareBannerManageView from '@/views/admin/PartnerSquareBannerManageView.vue'
import PartnerFeedbackManageView from '@/views/admin/PartnerFeedbackManageView.vue'

// Partners Auth Views
import PartnersIntroView from '@/views/partners/auth/PartnersIntroView.vue'
import PartnersLoginView from '@/views/partners/auth/PartnersLoginView.vue'
import PartnersRegisterView from '@/views/partners/auth/PartnersRegisterView.vue'
import PartnersStatusView from '@/views/partners/auth/PartnersStatusView.vue'

// Partners Views
import PartnersHomeView from '@/views/partners/PartnersHomeView.vue'
import MyPropertyView from '@/views/partners/property/MyPropertyView.vue'
import ChangePropertyView from '@/views/partners/property/ChangePropertyView.vue'
import ApplicationHistoryView from '@/views/partners/property/ApplicationHistoryView.vue'
// Partners Leads Views
import DesignatedLeadsView from '@/views/partners/leads/DesignatedLeadsView.vue'
import OpenLeadsView from '@/views/partners/leads/OpenLeadsView.vue'
import MyCustomersView from '@/views/partners/leads/MyCustomersView.vue'
import BannerLeadsView from '@/views/partners/leads/BannerLeadsView.vue'
// Partners Point Views
import PointManageView from '@/views/partners/coin/PointManageView.vue'
// Partners Jump Views
import JumpPurchaseView from '@/views/partners/jump/JumpPurchaseView.vue'
import MyJumpListView from '@/views/partners/jump/MyJumpListView.vue'
import JumpStatsView from '@/views/partners/jump/JumpStatsView.vue'
// Partners AD (Campaign) Views
import CampaignCreateView from '@/views/partners/ad/CampaignCreateView.vue'
import MyCampaignsView from '@/views/partners/ad/MyCampaignsView.vue'
// Partners AdBanner Views
import AdBannerPurchaseView from '@/views/partners/adbanner/AdBannerPurchaseView.vue'
import MyAdBannersView from '@/views/partners/adbanner/MyAdBannersView.vue'
// Partners Popup Ad Views
import PopupAdPurchaseView from '@/views/partners/popup/PopupAdPurchaseView.vue'
import MyPopupAdsView from '@/views/partners/popup/MyPopupAdsView.vue'
// Partners Splash Ad Views
import SplashAdPurchaseView from '@/views/partners/splash/SplashAdPurchaseView.vue'
import MySplashAdsView from '@/views/partners/splash/MySplashAdsView.vue'
// Partners Recommend Ad Views
import RecommendAdPurchaseView from '@/views/partners/recommend/RecommendAdPurchaseView.vue'
import MyRecommendAdsView from '@/views/partners/recommend/MyRecommendAdsView.vue'
// Partners List Ad Views
import ListAdPurchaseView from '@/views/partners/listad/ListAdPurchaseView.vue'
import MyListAdsView from '@/views/partners/listad/MyListAdsView.vue'
// Partners Community Ad Views
import CommunityAdPurchaseView from '@/views/partners/communityad/CommunityAdPurchaseView.vue'
import MyCommunityAdsView from '@/views/partners/communityad/MyCommunityAdsView.vue'
// Partners Chat Ad Views
import ChatAdPurchaseView from '@/views/partners/chatad/ChatAdPurchaseView.vue'
import MyChatAdsView from '@/views/partners/chatad/MyChatAdsView.vue'
// Partners Community & Notice Views
import PartnerCommunityView from '@/views/partners/community/PartnerCommunityView.vue'
import PartnerNoticeView from '@/views/partners/support/PartnerNoticeView.vue'
import PartnerUpdatesView from '@/views/partners/support/PartnerUpdatesView.vue'
import FeedbackView from '@/views/partners/support/FeedbackView.vue'
// Partners Chat View
import PartnersChatView from '@/views/partners/chat/PartnersChatView.vue'

// Main Campaign Landing
import CampaignLandingView from '@/views/main/campaign/CampaignLandingView.vue'

// Main Legal Views
import TermsView from '@/views/main/legal/TermsView.vue'
import PrivacyView from '@/views/main/legal/PrivacyView.vue'

// Main Mypage Views
import MypageView from '@/views/main/mypage/MypageView.vue'

const routes = [
  // Auth Routes
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guestOnly: true }
  },

  // Main (Public) Routes
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/properties',
    name: 'PropertyList',
    component: PropertyListView
  },
  {
    path: '/properties/:id',
    name: 'PropertyDetail',
    component: PropertyDetailView
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatView
  },

  // Community Routes
  {
    path: '/community',
    name: 'CommunityList',
    component: CommunityListView
  },
  {
    path: '/community/write',
    name: 'CommunityWrite',
    component: CommunityWriteView,
    meta: { requiresAuth: true }
  },
  {
    path: '/community/:id',
    name: 'CommunityDetail',
    component: CommunityDetailView
  },

  // Admin Routes
  {
    path: '/admin',
    name: 'AdminHome',
    component: AdminHomeView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/properties',
    name: 'AdminPropertyList',
    component: AdminPropertyListView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/properties/create',
    name: 'PropertyCreate',
    component: PropertyCreateView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/users',
    name: 'UserList',
    component: UserListView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner-applications',
    name: 'PartnerApplications',
    component: PartnerApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/banners',
    name: 'MainBannerManage',
    component: MainBannerManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/hot-ad',
    name: 'HotAdManage',
    component: HotAdManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/adbanner-applications',
    name: 'AdBannerApplications',
    component: AdBannerApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/popup-applications',
    name: 'PopupAdApplications',
    component: PopupAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/splash-applications',
    name: 'SplashAdApplications',
    component: SplashAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/magazines',
    name: 'MagazineManage',
    component: MagazineManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/notices',
    name: 'NoticeManage',
    component: NoticeManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner-notices',
    name: 'PartnerNoticeManage',
    component: PartnerNoticeManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/events',
    name: 'EventManage',
    component: EventManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/faq',
    name: 'FaqManage',
    component: FaqManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/inquiries',
    name: 'InquiryManage',
    component: InquiryManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Partners Point Charge Route
  {
    path: '/admin/point-charges',
    name: 'PointChargeManage',
    component: PointChargeManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/point-give',
    name: 'PointGive',
    component: PointGiveView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Recommend Ad Route
  {
    path: '/admin/recommend-applications',
    name: 'RecommendAdApplications',
    component: RecommendAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin List Ad Route
  {
    path: '/admin/listad-applications',
    name: 'ListAdApplications',
    component: ListAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Community Report Route
  {
    path: '/admin/community-reports',
    name: 'CommunityReportManage',
    component: CommunityReportManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Community Ad Route
  {
    path: '/admin/communityad-applications',
    name: 'CommunityAdApplications',
    component: CommunityAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Chat Ad Route
  {
    path: '/admin/chatad-applications',
    name: 'ChatAdApplications',
    component: ChatAdApplicationsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Partners Dashboard Routes
  {
    path: '/admin/partner-dashboard-banners',
    name: 'PartnerDashboardBannerManage',
    component: PartnerDashboardBannerManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner-updates',
    name: 'PartnerUpdateManage',
    component: PartnerUpdateManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner-square-banners',
    name: 'PartnerSquareBannerManage',
    component: PartnerSquareBannerManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner-feedbacks',
    name: 'PartnerFeedbackManage',
    component: PartnerFeedbackManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Admin Points Routes
  {
    path: '/admin/points/settings',
    name: 'PointSettings',
    component: PointSettingsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/points/products',
    name: 'ProductManage',
    component: ProductManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/points/orders',
    name: 'OrderManage',
    component: OrderManageView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Partners Auth Routes
  {
    path: '/partners/intro',
    name: 'PartnersIntro',
    component: PartnersIntroView,
    meta: { partnersIntro: true }
  },
  {
    path: '/partners/login',
    name: 'PartnersLogin',
    component: PartnersLoginView,
    meta: { guestOnlyPartners: true }
  },
  {
    path: '/partners/register',
    name: 'PartnersRegister',
    component: PartnersRegisterView,
    meta: { requiresAuth: true, checkPartnerApplication: true }
  },
  {
    path: '/partners/status',
    name: 'PartnersStatus',
    component: PartnersStatusView,
    meta: { requiresAuth: true }
  },

  // Partners Routes
  {
    path: '/partners',
    name: 'PartnersHome',
    component: PartnersHomeView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/property/my',
    name: 'MyProperty',
    component: MyPropertyView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/property/change',
    name: 'ChangeProperty',
    component: ChangePropertyView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/property/history',
    name: 'ApplicationHistory',
    component: ApplicationHistoryView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Leads Routes
  {
    path: '/partners/leads/designated',
    name: 'DesignatedLeads',
    component: DesignatedLeadsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/leads/open',
    name: 'OpenLeads',
    component: OpenLeadsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/leads/customers',
    name: 'MyCustomers',
    component: MyCustomersView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/leads/banner',
    name: 'BannerLeads',
    component: BannerLeadsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Point Routes
  {
    path: '/partners/point',
    name: 'PointManage',
    component: PointManageView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Jump Routes
  {
    path: '/partners/jump/purchase',
    name: 'JumpPurchase',
    component: JumpPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/jump/my',
    name: 'MyJumpList',
    component: MyJumpListView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/jump/stats',
    name: 'JumpStats',
    component: JumpStatsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners AD (Campaign) Routes
  {
    path: '/partners/ad/create',
    name: 'CampaignCreate',
    component: CampaignCreateView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/ad/my',
    name: 'MyCampaigns',
    component: MyCampaignsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners AdBanner Routes
  {
    path: '/partners/adbanner/purchase',
    name: 'AdBannerPurchase',
    component: AdBannerPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/adbanner/my',
    name: 'MyAdBanners',
    component: MyAdBannersView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Popup Ad Routes
  {
    path: '/partners/popup/purchase',
    name: 'PopupAdPurchase',
    component: PopupAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/popup/my',
    name: 'MyPopupAds',
    component: MyPopupAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Splash Ad Routes
  {
    path: '/partners/splash/purchase',
    name: 'SplashAdPurchase',
    component: SplashAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/splash/my',
    name: 'MySplashAds',
    component: MySplashAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Recommend Ad Routes
  {
    path: '/partners/recommend/purchase',
    name: 'RecommendAdPurchase',
    component: RecommendAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/recommend/my',
    name: 'MyRecommendAds',
    component: MyRecommendAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners List Ad Routes
  {
    path: '/partners/listad/purchase',
    name: 'ListAdPurchase',
    component: ListAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/listad/my',
    name: 'MyListAds',
    component: MyListAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Community Ad Routes
  {
    path: '/partners/communityad/purchase',
    name: 'CommunityAdPurchase',
    component: CommunityAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/communityad/my',
    name: 'MyCommunityAds',
    component: MyCommunityAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Chat Ad Routes
  {
    path: '/partners/chatad/purchase',
    name: 'ChatAdPurchase',
    component: ChatAdPurchaseView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/chatad/my',
    name: 'MyChatAds',
    component: MyChatAdsView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Partners Community & Notice Routes
  {
    path: '/partners/community',
    name: 'PartnerCommunity',
    component: PartnerCommunityView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/notice',
    name: 'PartnerNotice',
    component: PartnerNoticeView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/updates',
    name: 'PartnerUpdates',
    component: PartnerUpdatesView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  {
    path: '/partners/feedback',
    name: 'PartnerFeedback',
    component: FeedbackView,
    meta: { requiresAuth: true, requiresPartner: true }
  },
  // Partners Chat Route
  {
    path: '/partners/chat',
    name: 'PartnersChat',
    component: PartnersChatView,
    meta: { requiresAuth: true, requiresPartner: true }
  },

  // Campaign Landing Page (Public)
  {
    path: '/p/:code',
    name: 'CampaignLanding',
    component: CampaignLandingView
  },

  // Legal Routes (Public)
  {
    path: '/terms',
    name: 'Terms',
    component: TermsView
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyView
  },

  // Mypage Routes
  {
    path: '/mypage',
    name: 'Mypage',
    component: MypageView
  },
  {
    path: '/mypage/favorites',
    name: 'MypageFavorites',
    component: () => import('@/views/main/mypage/FavoritesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/recent',
    name: 'MypageRecent',
    component: () => import('@/views/main/mypage/RecentView.vue')
  },
  {
    path: '/mypage/interests',
    name: 'MypageInterests',
    component: () => import('@/views/main/mypage/InterestsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/settings',
    name: 'MypageSettings',
    component: () => import('@/views/main/mypage/SettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/notices',
    name: 'MypageNotices',
    component: () => import('@/views/main/mypage/NoticesView.vue')
  },
  {
    path: '/mypage/notices/:id',
    name: 'NoticeDetail',
    component: () => import('@/views/main/mypage/NoticeDetailView.vue')
  },
  {
    path: '/mypage/events',
    name: 'MypageEvents',
    component: () => import('@/views/main/mypage/EventsView.vue')
  },
  {
    path: '/mypage/events/:id',
    name: 'EventDetail',
    component: () => import('@/views/main/mypage/EventDetailView.vue')
  },
  {
    path: '/mypage/support',
    name: 'MypageSupport',
    component: () => import('@/views/main/mypage/SupportView.vue')
  },
  {
    path: '/mypage/support/inquiry/create',
    name: 'InquiryCreate',
    component: () => import('@/views/main/mypage/InquiryCreateView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/support/inquiry/:id',
    name: 'InquiryDetail',
    component: () => import('@/views/main/mypage/InquiryDetailView.vue'),
    meta: { requiresAuth: true }
  },

  // Mypage Points Routes
  // Mypage Community Routes
  {
    path: '/mypage/posts',
    name: 'MyPosts',
    component: () => import('@/views/main/mypage/community/MyPostsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/comments',
    name: 'MyComments',
    component: () => import('@/views/main/mypage/community/MyCommentsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/liked-posts',
    name: 'LikedPosts',
    component: () => import('@/views/main/mypage/community/LikedPostsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/bookmarks',
    name: 'Bookmarks',
    component: () => import('@/views/main/mypage/community/BookmarksView.vue'),
    meta: { requiresAuth: true }
  },

  // Mypage Points Routes
  {
    path: '/mypage/points',
    name: 'PointMain',
    component: () => import('@/views/main/mypage/points/PointMainView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/points/checkin',
    name: 'PointCheckIn',
    component: () => import('@/views/main/mypage/points/CheckInView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/points/history',
    name: 'PointHistory',
    component: () => import('@/views/main/mypage/points/PointHistoryView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/points/shop',
    name: 'PointShop',
    component: () => import('@/views/main/mypage/points/PointShopView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/points/orders',
    name: 'PointOrders',
    component: () => import('@/views/main/mypage/points/PointOrdersView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mypage/points/shop/:id',
    name: 'PointShopDetail',
    component: () => import('@/views/main/mypage/points/PointShopDetailView.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 파트너스 내부 페이지 이동 시 스크롤 유지 (사이드바 UX 개선)
    const isPartnersInternal = to.path.startsWith('/partners') && from.path.startsWith('/partners')
    if (isPartnersInternal) {
      // 파트너스 내부 이동은 스크롤 유지
      return false
    }

    // 저장된 위치가 있으면 (뒤로가기 등) 해당 위치로
    if (savedPosition) {
      return savedPosition
    }
    // 그 외에는 맨 위로
    return { top: 0 }
  }
})

// 현재 사용자 가져오기 (Promise)
const getCurrentUser = () => {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe()
      resolve(user)
    })
  })
}

// 사용자 프로필 가져오기
const getUserProfile = async (uid) => {
  try {
    const docSnap = await getDoc(doc(db, 'users', uid))
    return docSnap.exists() ? docSnap.data() : null
  } catch {
    return null
  }
}

// 파트너 신청 상태 가져오기
const getPartnerApplication = async (uid) => {
  try {
    const q = query(
      collection(db, 'partnerApplications'),
      where('partnerId', '==', uid),
      orderBy('createdAt', 'desc'),
      limit(1)
    )
    const snapshot = await getDocs(q)
    if (!snapshot.empty) {
      return {
        id: snapshot.docs[0].id,
        ...snapshot.docs[0].data()
      }
    }
    return null
  } catch {
    return null
  }
}

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const user = await getCurrentUser()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  const requiresPartner = to.matched.some((record) => record.meta.requiresPartner)
  const guestOnly = to.matched.some((record) => record.meta.guestOnly)
  const guestOnlyPartners = to.matched.some((record) => record.meta.guestOnlyPartners)

  // 게스트 전용 페이지 (로그인된 사용자 접근 불가)
  if (guestOnly && user) {
    return next('/')
  }

  // 파트너스 인트로 페이지 (로그인 시 적절한 페이지로)
  const partnersIntro = to.matched.some((record) => record.meta.partnersIntro)
  if (partnersIntro && user) {
    const profile = await getUserProfile(user.uid)
    if (profile && (profile.role === 'partner' || profile.role === 'admin')) {
      return next('/partners')
    } else {
      const application = await getPartnerApplication(user.uid)
      if (application && (application.status === 'pending' || application.status === 'rejected')) {
        return next('/partners/status')
      }
      // 로그인 됐지만 신청 없음 → 인트로 페이지 그대로 (등록 버튼 보여줌)
    }
  }

  // 파트너스 로그인 페이지 (로그인 시 역할에 따라 리다이렉트)
  if (guestOnlyPartners && user) {
    const profile = await getUserProfile(user.uid)
    if (profile && (profile.role === 'partner' || profile.role === 'admin')) {
      // 파트너/관리자 → 대시보드
      return next('/partners')
    } else {
      // 일반 사용자 → 신청 상태 확인
      const application = await getPartnerApplication(user.uid)
      if (application && (application.status === 'pending' || application.status === 'rejected')) {
        // 심사중/반려 → 상태 페이지
        return next('/partners/status')
      }
      // 신청 내역 없음 → 인트로 페이지
      return next('/partners/intro')
    }
  }

  // 인증 필요한 페이지
  if (requiresAuth && !user) {
    // 파트너스 관련 페이지는 파트너스 인트로로
    if (to.path.startsWith('/partners')) {
      return next({ path: '/partners/intro' })
    }
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // Admin 권한 필요
  if (requiresAdmin && user) {
    const profile = await getUserProfile(user.uid)
    if (!profile || profile.role !== 'admin') {
      return next('/')
    }
  }

  // Partner 권한 필요 (partner 또는 admin 허용)
  if (requiresPartner && user) {
    const profile = await getUserProfile(user.uid)
    if (!profile || (profile.role !== 'partner' && profile.role !== 'admin')) {
      // 파트너 아닌 경우 → 신청 상태 확인
      const application = await getPartnerApplication(user.uid)
      if (application && (application.status === 'pending' || application.status === 'rejected')) {
        return next('/partners/status')
      }
      return next('/partners/register')
    }
  }

  // 파트너 등록 페이지 접근 시 신청 상태 체크
  const checkPartnerApplication = to.matched.some((record) => record.meta.checkPartnerApplication)
  if (checkPartnerApplication && user) {
    const profile = await getUserProfile(user.uid)
    // 이미 파트너면 대시보드로
    if (profile && (profile.role === 'partner' || profile.role === 'admin')) {
      return next('/partners')
    }
    // pending 상태면 상태 페이지로
    const application = await getPartnerApplication(user.uid)
    if (application && application.status === 'pending') {
      return next('/partners/status')
    }
    // rejected 또는 신청 없음 → 등록 페이지 접근 허용
  }

  next()
})

export default router
